/* Maps any common shorthand or misspelling to our 3 allowed values. */
export function normalizeGender(value: unknown): 'male' | 'female' | 'other' {
  if (typeof value !== 'string') return 'other';
  const v = value.trim().toLowerCase();

  if (['m', 'male', 'man', 'boy'].includes(v)) return 'male';
  if (['f', 'female', 'woman', 'girl'].includes(v)) return 'female';

  return 'other';
}
